import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changeShowForm } from "../../store/reducers/thunk";
import continueArrow from "../../assets/VectorHablemos.svg";
import colorsLine from "../../assets/brand/colors_line.png";
import PD_G_logo from "../../assets/PD_G_logo.svg";
import adecc from "../../assets/membersLogos/adecc.png";
import amcham from "../../assets/membersLogos/amcham.png";
import cci from "../../assets/membersLogos/cci.png";
import comercioDominicoMexicano from "../../assets/membersLogos/comercio-dominico-mexicana.png";
import comercioEspana from "../../assets/membersLogos/comercio-espana.png";

interface FooterProps {
  scrollTo?: (section: React.RefObject<HTMLDivElement>) => void;
  goToSelectionRef?: React.RefObject<HTMLDivElement>;
  isSimple?: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  scrollTo,
  goToSelectionRef,
  isSimple = false,
}) => {
  const dispatch = useDispatch();

  const showFrom = () => {
    dispatch(changeShowForm(true));
  };

  return (
    <>
      {!isSimple ? (
        <footer className="bg-black text-white">
          {/* Call to Action Section */}
          <div className="container mx-auto px-4 py-12 md:py-16 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-8 font-montserrat">
              Transformando tus <br />
              ideas en realidad
            </h2>
            <div className="flex items-center justify-center gap-2 group hover:scale-105 transition-transform duration-200">
              <button
                onClick={showFrom}
                className="text-white underline text-lg font-montserrat"
              >
                Hablemos
              </button>
              <img src={continueArrow} className="w-4 h-4" alt="Arrow" />
            </div>
          </div>

          {/* Members Section */}
          <div className="border-t border-white/10">
            <div className="container mx-auto px-4 pt-10 pb-12">
              <h3 className="text-sm md:text-base font-semibold uppercase tracking-[0.25em] text-gray-400 text-center mb-8 font-montserrat">
                Somos miembros
              </h3>
              <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 w-full">
                <img
                  draggable={false}
                  src={adecc}
                  alt="Adecc"
                  className="h-12 sm:h-8 w-auto object-contain filter brightness-0 invert opacity-80"
                />
                <img
                  draggable={false}
                  src={comercioEspana}
                  alt="Cámara de Comercio de España"
                  className="md:h-12 h-8 w-auto object-contain filter brightness-0 invert opacity-80"
                />
                <img
                  draggable={false}
                  src={amcham}
                  alt="AMCHAM"
                  className="md:h-12 h-8 w-auto object-contain filter brightness-0 invert opacity-80"
                />
                <img
                  draggable={false}
                  src={comercioDominicoMexicano}
                  alt="Cámara de Comercio Dominico Mexicana"
                  className="md:h-12 h-8 w-auto object-contain filter brightness-0 invert opacity-80"
                />
                <img
                  draggable={false}
                  src={cci}
                  alt="CCI Franco Dominicana"
                  className="md:h-12 h-8 w-auto object-contain filter brightness-0 invert opacity-80"
                />
              </div>
            </div>
          </div>

          {/* Rainbow Gradient Line */}
          <img
            draggable={false}
            src={colorsLine}
            alt="Colors Line"
            className="w-full"
          />
          {/* Main Footer Content */}
          <div className="container mx-auto px-4 py-12">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
              {/* Only desktop */}
              <div className="w-full flex md:hidden flex-col justify-center items-center gap-4">
                <img
                  draggable={false}
                  src={PD_G_logo}
                  alt="Grupo Peña Defilló Logo"
                  className="w-full h-6 md:h-12 object-contain"
                />
              </div>
              <div className="hidden md:flex flex-col text-left">
                <h4 className="text-xl font-bold mb-4 font-montserrat">
                  ¡SIGUENOS!
                </h4>
                <div className="flex flex-col gap-2">
                  <a
                    href="https://www.linkedin.com/company/grupopenadefillo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    LINKEDIN
                  </a>
                  <a
                    href="https://www.instagram.com/pena.defillo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    INSTAGRAM
                  </a>
                  <a
                    href="https://www.youtube.com/@grupopenadefillo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    YOUTUBE
                  </a>
                </div>
              </div>

              {/* Navigation Links */}
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-6 md:gap-8 w-full md:w-auto">
                <Link
                  to="/home/portafolio"
                  onClick={() => scrollTo(goToSelectionRef)}
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  PORTAFOLIO
                </Link>
                <Link
                  to="/careers"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  EMPLEOS
                </Link>
                <Link
                  to="/about"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  SOBRE NOSOTROS
                </Link>
                <button
                  onClick={showFrom}
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  CONTÁCTANOS
                </button>
                <a
                  href="https://goo.gl/maps/sHnehVLCdqHvbGyH8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  UBICACIÓN
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Section - Copyright and Privacy */}
          <div className="border-t border-gray-600">
            {/* <div className="border-t border-gray-600 hidden md:block"> */}
            <div className="container mx-auto px-4 py-6">
              <div className="flex flex-col md:flex-row justify-center items-center gap-4 font-montserrat">
                {/* Copyright and Privacy */}
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <span>&copy; Peña Defilló {new Date().getFullYear()}</span>
                  <span>•</span>
                  {/* href="https://penadefillo.com/static/media/privacypolicy-GPD.96f1947b3d48aa7a020e.pdf" */}
                  <a
                    href="/privacy-policy"
                    rel="noopener noreferrer"
                    className="text-white hover:underline transition-colors duration-200 cursor-pointer"
                  >
                    Política de Privacidad
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      ) : (
        <footer className="bg-black text-white">
          {/* Rainbow Gradient Line */}
          <img
            draggable={false}
            src={colorsLine}
            alt="Colors Line"
            className="w-full"
          />
          {/* Main Footer Content */}
          <div className="container mx-auto px-4 py-12">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
              {/* Only desktop */}
              <div className="w-full flex md:hidden flex-col justify-center items-center gap-4">
                <img
                  draggable={false}
                  src={PD_G_logo}
                  alt="Grupo Peña Defilló Logo"
                  className="w-full h-6 md:h-12 object-contain"
                />
              </div>
              <div className="hidden md:flex flex-col text-left">
                <h4 className="text-xl font-bold mb-4 font-montserrat">
                  ¡SIGUENOS!
                </h4>
                <div className="flex flex-col gap-2">
                  <a
                    href="https://www.linkedin.com/company/grupopenadefillo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    LINKEDIN
                  </a>
                  <a
                    href="https://www.instagram.com/pena.defillo/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    INSTAGRAM
                  </a>
                  <a
                    href="https://www.youtube.com/@grupopenadefillo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white text-sm md:text-base  hover:scale-105 transition-transform duration-200 font-montserrat"
                  >
                    YOUTUBE
                  </a>
                </div>
              </div>

              {/* Navigation Links */}
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-6 md:gap-8 w-full md:w-auto">
                <Link
                  to="/home/portafolio"
                  onClick={() => scrollTo(goToSelectionRef)}
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  PORTAFOLIO
                </Link>
                <Link
                  to="/careers"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  EMPLEOS
                </Link>
                <Link
                  to="/about"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  SOBRE NOSOTROS
                </Link>
                <button
                  onClick={showFrom}
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  CONTÁCTANOS
                </button>
                <a
                  href="https://goo.gl/maps/sHnehVLCdqHvbGyH8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white text-sm md:text-base hover:scale-105 transition-transform duration-200 font-montserrat"
                >
                  UBICACIÓN
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Section - Copyright and Privacy */}
          <div className="border-t border-gray-600">
            {/* <div className="border-t border-gray-600 hidden md:block"> */}
            <div className="container mx-auto px-4 py-6">
              <div className="flex flex-col md:flex-row justify-center items-center gap-4 font-montserrat">
                {/* Copyright and Privacy */}
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <span>&copy; Peña Defilló {new Date().getFullYear()}</span>
                  <span>•</span>
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:underline transition-colors duration-200 cursor-pointer"
                  >
                    Política de Privacidad
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
